import React, { useState } from "react";
import { useGame } from "../context/GameContext";

export default function IntentionModal({ onClose }) {
  const { createIntention, categories } = useGame();
  const [text, setText] = useState("");
  const [category, setCategory] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    if (!text.trim()) { setError("Write your intention first."); return; }
    if (!category) { setError("Pick a category."); return; }
    setSaving(true);
    try {
      await createIntention(text.trim(), category);
      onClose();
    } catch (e) {
      setError("Failed to save. Try again.");
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-box">
        <div className="modal-header">
          <span className="modal-title">NEW INTENTION</span>
          <button className="modal-close" onClick={onClose}>X</button>
        </div>
        <textarea
          className="intention-textarea"
          placeholder="What do you intend to do today?"
          value={text}
          onChange={e => { setText(e.target.value); setError(""); }}
          rows={3}
          autoFocus
        />
        <div className="category-grid">
          {categories.map(cat => (
            <button
              key={cat.id}
              className={`cat-btn ${category === cat.name ? "cat-selected" : ""}`}
              style={{ "--cat-color": cat.color }}
              onClick={() => { setCategory(cat.name); setError(""); }}
            >
              <span className="cat-name" style={{ color: category === cat.name ? cat.color : "inherit" }}>
                {cat.name}
              </span>
            </button>
          ))}
        </div>
        {error && <div className="modal-error">{error}</div>}
        <button className="btn-primary" onClick={handleSubmit} disabled={saving}>
          {saving ? "SAVING..." : "SET INTENTION"}
        </button>
      </div>
    </div>
  );
}
